
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[author]/[slug]",
      function () {
        return require("private-next-pages/blog/[author]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[author]/[slug]"])
      });
    }
  